// Hostname-aware routing so a single deployment serves two domains:
//   recoveros.in       -> marketing website (landing page at "/")
//   app.recoveros.in   -> RecoverOS application (login / dashboard at "/")
// Preview/localhost behave like the marketing host (landing at "/") so the
// full site stays testable from one URL.

const HOST = typeof window !== "undefined" ? window.location.hostname : "";

export const IS_APP_HOST = HOST.startsWith("app.");
export const IS_PREVIEW =
  HOST.includes("preview.emergentagent.com") || HOST === "localhost" || HOST === "127.0.0.1";
// A real marketing apex/root domain (e.g. recoveros.in or www.recoveros.in)
export const IS_MARKETING_HOST = !IS_APP_HOST && !IS_PREVIEW;

// Origin of the application for the current marketing domain (recoveros.in -> https://app.recoveros.in)
function appOrigin() {
  const bare = HOST.replace(/^www\./, "");
  return `${window.location.protocol}//app.${bare}`;
}

// Navigate to an app route. On the marketing domain this jumps to the app
// subdomain; everywhere else it routes within the same origin via react-router.
export function goToApp(path, navigate) {
  if (IS_MARKETING_HOST) {
    window.location.href = appOrigin() + path;
  } else {
    navigate(path);
  }
}
